import React from "react";

export default function StatusBar({ tool, contentBox, playing, selectedCount = 0 }) {
  const sizeLabel = contentBox
    ? `${Math.round(contentBox.w)} × ${Math.round(contentBox.h)}`
    : "∞ INFINITE CANVAS";
  return (
    <div className="absolute bottom-0 left-0 right-0 h-7 border-t border-line bg-chrome flex items-center justify-between px-4 text-[10px] font-mono uppercase tracking-widest text-ink4">
      <span data-testid="status-tool">TOOL: {tool}</span>
      <span data-testid="status-selection">
        {selectedCount > 0 ? `${selectedCount} SELECTED · ` : ""}
        {sizeLabel}
      </span>
      <span data-testid="status-playing">{playing ? "▶ PLAYING" : "❚❚ PAUSED"}</span>
    </div>
  );
}
